import React from 'react'
import {Navbar, Footer} from './../components';
import { Principal, Projects, Contact, Habilidades} from './index'

function Home() {

  return (
    <div>
        <Navbar/>
        <Principal/>
        <Habilidades/>
        <Projects/>
        <Contact/>
        <Footer/>
    </div>
  )
}

export default Home